import cn from 'classnames';
import { Col } from '../../col';
import { FileIcon } from '../../file-icon';
import { Icon } from '../../icons';
import { Row } from '../../row';
import { Text } from '../../typography';
import { InputAttachmentWrapper } from '../input-attachment-wrapper';
import styles from './input-file-attachment.module.css';

export type InputFileAttachmentData = {
  contentType?: string;
  filename: string;
  isLoading?: boolean;
  url?: string;
};

export type InputFileAttachmentProperties = {
  attachment: InputFileAttachmentData;
  onRemove: (attachment: InputFileAttachmentData) => void;
  size?: InputFileAttachmentSize;
};

export type InputFileAttachmentSize = 'default' | 'small';

const InputFileAttachment = ({ attachment, onRemove, size = 'default' }: InputFileAttachmentProperties) => {
  const { contentType, filename, isLoading, url } = attachment;

  return (
    <InputAttachmentWrapper
      className={cn({
        [styles['wrapper--small'] ?? '']: size === 'small',
      })}
      onRemove={() => {
        onRemove(attachment);
      }}
    >
      <Row align="middle" gutter="xs" wrap={false}>
        <Col alignItems="center">
          {isLoading ? (
            <Icon color="text" icon="loading-line" size="middle" spin />
          ) : (
            <FileIcon contentType={contentType} imagePreview={false} url={url} />
          )}
        </Col>
        <Col className={styles.shrink} flex="1 1 0">
          <Text ellipsis={{ tooltip: filename }}>{filename}</Text>
        </Col>
      </Row>
    </InputAttachmentWrapper>
  );
};

export default InputFileAttachment;
